import { Button } from '@amzn/stencil-react-components/button';
import { Checkbox } from '@amzn/stencil-react-components/checkbox';
import { Col, Row, Spacer } from '@amzn/stencil-react-components/layout';
import { Label, Text } from '@amzn/stencil-react-components/text';
import cloneDeep from 'lodash/cloneDeep';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { updateMetricNames, updateTenureOperators } from '../../../actions/initializeDataActions';
import {
  updateActiveFilters,
  updateMetricName,
  updateMetricOperator,
  updateMetricValue,
  updateMetricFilter,
} from '../../../actions/ruleFiltersActions';
import { SegmentFilters } from '../../../constants/createSegment';
import {
  activeRuleFiltersSelector,
  initialDataSelector,
  ruleFilterMetricNameSelector,
  ruleFilterMetricOperatorSelector,
  ruleFilterMetricValueSelector,
  ruleFiltersSelector,
} from '../../../selectors/selectors';
import MetricSection from './MetricSection';

const MetricFilter = () => {
  const dispatch = useDispatch();
  const activeFilters = useSelector(activeRuleFiltersSelector);
  const { metrics } = useSelector(ruleFiltersSelector);
  const metricValue = useSelector(ruleFilterMetricValueSelector);
  const metricName = useSelector(ruleFilterMetricNameSelector);
  const metricOperator = useSelector(ruleFilterMetricOperatorSelector);
  const { metricNamesOptions, tenureOperatorOptions } = useSelector(initialDataSelector);

  const [isDisabled, setIsDisabled] = useState(
    !activeFilters?.includes(SegmentFilters.METRIC_FILTER),
  );

  useEffect(() => {
    dispatch(updateMetricNames());
    dispatch(updateTenureOperators());
  }, []);

  const onAddMetric = () => {
    const metricList = [...metrics];
    metricList.push({
      metricName: '',
      metricOperator: '',
      metricValue: '',
    });
    dispatch(updateMetricFilter(metricList));
  };
  return (
    <>
      <Row gridGap="S100">
        <Checkbox data-testid="rule-filter-7" checked={!isDisabled} />
        <Label display="flex" fontSize={'T300'} htmlFor="rule-filter-7" id="rule-filter-label7">
          <Text style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
            <FormattedMessage id="app.ruleFilter.label.metric" defaultMessage="Metric" />
          </Text>
          <Text fontSize={'T100'} style={{ fontWeight: 'bolder' }} color="primary">
            *
          </Text>
        </Label>
      </Row>
      <Spacer height={15} />
      <Row gridGap="S200" display="flex" flexDirection="column">
        {metrics?.map((metric, index) => {
          return <MetricSection metric={metric} index={index} />;
        })}
      </Row>
      <Spacer height={15} />
      <Row>
        <Col alignItems="start" display="flex">
          <Button data-testid="add-another-btn" fontSize="T500" tertiary onClick={onAddMetric}>
            <FormattedMessage
              id="app.createSegment.label.addMetricRule"
              defaultMessage="+ Add metric rule"
            />
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default MetricFilter;
